import liveSurveyService from '../services/liveSurveyService';

// Survey CRUD Operations
export const createLiveSurvey = async (payload) => {
  const result = await liveSurveyService.createLiveSurvey(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Canlı anket oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateLiveSurvey = async (payload) => {
  const result = await liveSurveyService.updateLiveSurvey(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Canlı anket güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteLiveSurvey = async (id) => {
  const result = await liveSurveyService.deleteLiveSurvey(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Canlı anket silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchLiveSurveyById = async (id) => {
  const result = await liveSurveyService.getLiveSurveyById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Canlı anket alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchAllLiveSurveys = async (params) => {
  const result = await liveSurveyService.getAllLiveSurveys(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Canlı anketler alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchLiveSurveysByEventId = async (eventId) => {
  const result = await liveSurveyService.getLiveSurveysByEventId(eventId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Etkinlik anketleri alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Question Management
export const addQuestionToSurvey = async (surveyId, payload) => {
  const result = await liveSurveyService.addQuestion(surveyId, payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Soru eklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateQuestionInSurvey = async (surveyId, payload) => {
  const result = await liveSurveyService.updateQuestion(surveyId, payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Soru güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteQuestionFromSurvey = async (surveyId, questionId) => {
  const result = await liveSurveyService.deleteQuestion(surveyId, questionId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Soru silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderSurveyQuestions = async (surveyId, questionIds) => {
  const result = await liveSurveyService.reorderQuestions(surveyId, questionIds);
  if (!result?.success) {
    const error = new Error(result?.message || 'Sorular sıralanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Survey Control
export const setSurveyActiveStatus = async (surveyId, isActive) => {
  const result = await liveSurveyService.setSurveyActive(surveyId, isActive);
  if (!result?.success) {
    const error = new Error(result?.message || 'Anket durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const setSurveyCurrentQuestion = async (surveyId, questionIndex) => {
  const result = await liveSurveyService.setCurrentQuestion(surveyId, questionIndex);
  if (!result?.success) {
    const error = new Error(result?.message || 'Aktif soru güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const moveToNextQuestion = async (surveyId) => {
  const result = await liveSurveyService.nextQuestion(surveyId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Sonraki soruya geçilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const moveToPreviousQuestion = async (surveyId) => {
  const result = await liveSurveyService.previousQuestion(surveyId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Önceki soruya geçilemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

// Report
export const fetchQuestionReport = async (surveyId, questionId) => {
  const result = await liveSurveyService.getQuestionReport(surveyId, questionId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Rapor alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

